import { ThunkAction } from 'redux-thunk'
import { Dispatch } from 'redux'
import { RootState } from '../reducer'
import { AuthConstants } from './constants'
import { AuthAction, AuthState, Profile } from './types'
import { User } from '../../api'

type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AuthAction
>

export const setAuthInfo = (
  authInfo: Partial<AuthState>
): AppThunk => {
  return (dispatch: Dispatch<AuthAction>) => {
    dispatch({
      type: AuthConstants.SET_AUTH_INFO,
      response: authInfo,
    })
  }
}

export const deleteAuthInfo = (): AppThunk => {
  return (dispatch: Dispatch<AuthAction>) => {
    dispatch({
      type: AuthConstants.DELETE_AUTH_INFO,
    })
  }
}

export const setUserProfile = (profile: Profile): AppThunk => {
  return (dispatch: Dispatch<AuthAction>) => {
    dispatch({
      type: AuthConstants.SET_USER_PROFILE,
      response: profile,
    })
  }
}

export const updateUser = (partialUserInfo: Partial<User>): AppThunk => {
  return (dispatch: Dispatch<AuthAction>) => {
    dispatch({
      type: AuthConstants.UPDATE_USER,
      response: partialUserInfo,
    })
  }
}
